import { atom, atomFamily, selector } from 'recoil';

import { intelligenceAiState } from 'components/state';

export const chatInputState = atom({
  key: 'chatInputState',
  default: null
});

export const hasChatInputTextState = selector({
  key: 'hasChatInputTextState',
  get: ({ get }) => Object.values(get(chatInputState) || {}).some((text) => !!(text || '').trim())
});

export const chatAttachedFilesState = atom({
  key: 'chatAttachedFilesState',
  default: [],
  dangerouslyAllowMutability: true
});

export const specialtyState = atom({
  key: 'specialtyState',
  default: null
});

export const intelligenceChatIdState = atom({
  key: 'intelligenceChatIdState',
  default: null
});

export const intelligenceChatMessageIdState = atom({
  key: 'intelligenceChatMessageIdState',
  default: null
});

export const promptListState = atom({
  key: 'promptListState',
  default: []
});

export const activePromptConversationsState = atom({
  key: 'activePromptConversationsState',
  default: []
});

export const myScribeAILoadingState = atom({
  key: 'myScribeAILoadingState',
  default: false
});

export const myScribeAcknowledged = atom({
  key: 'myScribeAcknowledged',
  default: false
});

export const myScribeAutoMapSelectedNoteTypeState = atom({
  key: 'myScribeAutoMapSelectedNoteTypeState',
  default: null
});

export const myScribeAutoMapActivePromptIdState = atom({
  key: 'myScribeAutoMapActivePromptIdState',
  default: null
});

export const isAIGeneratingState = atom({
  key: 'isAIGeneratingState',
  default: false
});

export const enhanceNoteLoadingState = atom({
  key: 'enhanceNoteLoadingState',
  default: []
});

export const abortedEnhanceFormsState = atom({
  key: 'abortedEnhanceFormsState',
  default: []
});

export const pendingAbortTaskIdsState = atom({
  key: 'pendingAbortTaskIdsState',
  default: null
});

// Derived: aborting iff at least one of the task_ids snapshotted at user's
// stop click is still in flight. Auto-clears when aborted tasks drain via
// any path (abort ack, done, error) — no stuck modal on lost/mismatched
// abort acks.
export const enhanceAbortingState = selector({
  key: 'enhanceAbortingState',
  get: ({ get }) => {
    const pending = get(pendingAbortTaskIdsState);
    if (!pending?.length) return false;
    const active = get(intelligenceAiState)?.activeTaskIds ?? [];
    return pending.some((id) => active.includes(id));
  },
  set: ({ get, set }, newValue) => {
    if (newValue) {
      const active = get(intelligenceAiState)?.activeTaskIds ?? [];
      set(pendingAbortTaskIdsState, active);
    } else {
      set(pendingAbortTaskIdsState, null);
    }
  }
});

export const myScribeStagedAppointmentIdState = atom({
  key: 'myScribeStagedAppointmentIdState',
  default: null
});

export const MYSCRIBE_CHAT_SCOPES = {
  chat: 'chat',
  ambient: 'ambient',
  ambientRefine: 'ambientRefine'
};

export const myScribeInputTagsState = atomFamily({
  key: 'myScribeInputTagsState',
  default: [],
  dangerouslyAllowMutability: true
});

export const myScribeSelectedTableRowsState = atomFamily({
  key: 'myScribeSelectedTableRowsState',
  default: {},
  dangerouslyAllowMutability: true
});

export const responseMapEditingSectionsState = atomFamily({
  key: 'responseMapEditingSectionsState',
  default: new Set()
});

export const myScribeTemplateModalState = atom({
  key: 'myScribeTemplateModalState',
  default: { isOpen: false, template: null }
});

export const selectedChatTemplateState = atom({
  key: 'selectedChatTemplateState',
  default: null
});

export const editedMessageIdsState = atom({
  key: 'editedMessageIdsState',
  default: new Set()
});

export const editedChatIdState = atom({
  key: 'editedChatIdState',
  default: null
});

export const myScribeNoteIsAllEditingState = atom({
  key: 'myScribeNoteIsAllEditingState',
  default: false
});

export const myScribeNoteEditRequestState = atom({
  key: 'myScribeNoteEditRequestState',
  default: 0
});
